var map = {
	"./Android_2025_de.pdf": 9082,
	"./Android_2025_en.pdf": 4676,
	"./Android_2025_es.pdf": 7362,
	"./Android_2025_fr.pdf": 8044,
	"./Android_2025_pl.pdf": 8871
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8921;